import { render, staticRenderFns } from "./ReminderTypeForm.vue?vue&type=template&id=31dd8d97&"
import script from "./ReminderTypeForm.vue?vue&type=script&lang=js&"
export * from "./ReminderTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./ReminderTypeForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports